import { FC } from 'react';

interface Props {
  color?: string;
  height?: string;
  width?: string;
  title?: string;
  strokeWidth?: string;
  className?: string;
}

const IconClose: FC<Props> = ({
  color = 'var(--color-white)',
  height = '14',
  width = '14',
  title = 'Close',
  strokeWidth = '2',
  className = '',
}) => {
  return (
    <svg
      aria-label={title}
      width={width}
      height={height}
      stroke={color}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13 1L1 13M1 1L13 13"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <title>{title}</title>
    </svg>
  );
};

export default IconClose;
